import { MutableRefObject, useLayoutEffect, useRef } from "react"
import { IntersectionOptions, useInView } from "react-intersection-observer"

import { ROOT_SCROLLABLE_ELEMENT } from "../../constants"

// This hook is necessary when using the rootMargin property, as it uses our scrollable container as root from which the rootMargin is calculated.
// Using the document as the root does not work in our case.
// For more details, see the documentation: https://github.com/thebuilder/react-intersection-observer?tab=readme-ov-file#api
export const useInViewRoot = (
  options: IntersectionOptions = {},
  absolutePositioned = true,
) => {
  const root: MutableRefObject<HTMLElement | null> = useRef<HTMLElement>(null)

  useLayoutEffect(() => {
    root.current = document.getElementById(ROOT_SCROLLABLE_ELEMENT)
  }, [])

  return useInView({
    // for absolutePositioned document will be root element. default for react-intersection-observer
    root: absolutePositioned ? undefined : root.current,
    ...options,
  })
}
